var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.72 15.38-3.21-3.2a7.478 7.478 0 0 0 1.596-4.627 7.553 7.553 0 1 0-7.553 7.553 7.478 7.478 0 0 0 4.626-1.595l3.201 3.21a.944.944 0 0 0 1.34 0 .944.944 0 0 0 0-1.341ZM1.889 7.553a5.665 5.665 0 1 1 11.33 0 5.665 5.665 0 0 1-11.33 0Z",
    fill: "#212121",
    fillRule: "nonzero"
  })));
};
export default SvgSearch;